var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDtmf0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,64c2.9,0,5.8-0.4,8.5-1.1s5.3-1.8,7.6-3.2s4.5-3.1,6.5-5s3.6-4.1,5-6.5s2.5-4.9,3.2-7.6S64,34.9,64,32s-0.4-5.8-1.1-8.5 s-1.8-5.3-3.2-7.6s-3.1-4.5-5-6.5s-4.1-3.6-6.5-5s-4.9-2.5-7.6-3.2S34.9,0,32,0s-5.8,0.4-8.5,1.1S18.2,3,15.9,4.4s-4.5,3.1-6.5,5 s-3.6,4.1-5,6.5s-2.5,4.9-3.2,7.6S0,29.1,0,32s0.4,5.8,1.1,8.5s1.8,5.3,3.2,7.6s3.1,4.5,5,6.5s4.1,3.6,6.5,5s4.9,2.5,7.6,3.2 S29.1,64,32,64z M32,4c2.6,0,5.1,0.3,7.5,1s4.6,1.6,6.7,2.8s4,2.7,5.7,4.4s3.2,3.6,4.4,5.7s2.2,4.3,2.8,6.7s1,4.9,1,7.5 s-0.3,5.1-1,7.5s-1.6,4.6-2.8,6.7s-2.7,4-4.4,5.7s-3.6,3.2-5.7,4.4s-4.3,2.2-6.7,2.8s-4.9,1-7.5,1s-5.1-0.3-7.5-1s-4.6-1.6-6.7-2.8 s-4-2.7-5.7-4.4S9,48.2,7.8,46.1S5.7,41.8,5,39.5S4,34.6,4,32s0.3-5.1,1-7.5s1.6-4.6,2.8-6.7s2.7-4,4.4-5.7s3.6-3.2,5.7-4.4 s4.3-2.2,6.7-2.8S29.4,4,32,4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.4,13.9c-1.8,0-3.4,0.4-4.9,1.2c-1.4,0.8-2.6,1.9-3.6,3.4c-1,1.5-1.7,3.4-2.2,5.7C21.3,26.4,21,29,21,31.9 c0,2.7,0.2,5,0.7,7.1c0.5,2.1,1.2,3.8,2.1,5.2c0.9,1.4,2,2.5,3.3,3.2c1.3,0.7,2.8,1.1,4.5,1.1c1.8,0,3.4-0.4,4.8-1.2 c1.4-0.8,2.6-1.9,3.5-3.4c1-1.5,1.7-3.3,2.2-5.5c0.5-2.2,0.8-4.7,0.8-7.5C42.9,19.6,39.4,13.9,32.4,13.9L32.4,13.9z M32,45.4 c-4.7,0-7.1-4.5-7.1-13.6c0-9.7,2.4-14.6,7.2-14.6c4.5,0,6.8,4.8,6.8,14.3C39,40.7,36.7,45.4,32,45.4L32,45.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtmf0);
export default __webpack_public_path__ + "static/media/dtmf-0.e1140ac1.svg";
export { ForwardRef as ReactComponent };